import React from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { FaRegUser } from "react-icons/fa";
import { MdSummarize, MdTranscribe } from "react-icons/md";
import RelatedCallsBlock from "./RelatedCallsBlock";
import MAudioPlayer from "../../../components/MAudioPlayer";
import CustomCopyToClipboard from "../../../components/Kit/CustomCopyToClipboard";
import { transformFromUTC, transformFromUTCFromISO } from "../../../utils/dateUtils";

const MenuButton = ({ icon: Icon, label, is_active, on_click }) => (
  <button
    type="button"
    onClick={on_click}
    className={`flex items-center gap-2.5 px-3 py-2 rounded-lg text-left w-full transition-colors ${
      is_active ? "bg-primary/10 text-primary" : "hover:bg-gray-100"
    }`}
  >
    <Icon
      size={20}
      className={is_active ? "text-primary" : "text-gray-400"}
    />
    <span className={`text-sm ${is_active ? "font-semibold" : "font-medium"}`}>{label}</span>
  </button>
);

const LeftPanel = ({ item, left_menu_tab, set_left_menu_tab, has_dpt, display_tz }) => {
  const { t } = useTranslation();
  return (
    <div className="w-[261px] flex flex-col border-r border-gray-200 bg-white">
      <div className="p-3">
        <div className="flex flex-col gap-1">
          <MenuButton
            icon={MdSummarize}
            label={t("Détails de l'appel")}
            is_active={left_menu_tab === "summary"}
            on_click={() => set_left_menu_tab("summary")}
          />
          <MenuButton
            icon={MdTranscribe}
            label={t("Transcription")}
            is_active={left_menu_tab === "transcription"}
            on_click={() => set_left_menu_tab("transcription")}
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-1">
        <RelatedCallsBlock
          item={item}
          display_tz={display_tz}
        />
      </div>
      <div className="p-3 border-t border-gray-100">
        <div className="flex items-center gap-2 mb-4">
          <FaRegUser
            size={14}
            className="text-gray-400"
          />
          <CustomCopyToClipboard
            displayText={
              item?.client_number && item.client_number !== "None"
                ? item.client_number
                : t("Inconnu")
            }
            copyText={
              item?.client_number && item.client_number !== "None" ? item.client_number : ""
            }
            displayClassName="text-sm font-medium text-gray-900"
            wrapperClassName="!p-0"
          />
        </div>
        <div className="mb-4">
          <MAudioPlayer
            autoPlay={false}
            mode="live"
            className="!rounded-lg !bg-transparent"
          />
        </div>
        <div className="border-t border-gray-100 pt-3">
          <p className="text-xs text-gray-400 mb-2">{t("Effectué par")}</p>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
              <span className="text-gray-600 font-semibold text-xs">
                {item?.operator_name?.charAt(0)?.toUpperCase() || "?"}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate capitalize">
                {item?.operator_name}
              </p>
              {has_dpt && <p className="text-xs text-gray-500 truncate">{item.department}</p>}
            </div>
          </div>
        </div>
        {item?.call_timestamp && (
          <div className="border-t border-gray-100 pt-3 mt-3">
            <p className="text-xs text-gray-400">
              {Number.isInteger(item.call_timestamp)
                ? format(transformFromUTC(item.call_timestamp, display_tz), "dd/MM/yyyy HH:mm")
                : format(
                    transformFromUTCFromISO(item.call_timestamp, display_tz),
                    "dd/MM/yyyy HH:mm"
                  )}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeftPanel;
